import { Component, Input } from '@angular/core';
import { AppSettings } from '../../app.settings';
@Component({
	selector: 'basic-header',
	template: require('./basic-header.component.html'),
})
export class BasicHeaderComponent {
	@Input() title: string;
	@Input() icon: string;
	public isRebrading = AppSettings.isRebrading;
	constructor() {}
}
